"use client";

import { Content } from "@/services/content/types";
import { createContext, PropsWithChildren, useContext, useState } from "react";

type PlayerContextType = {
  podcast: Content.PodcastEpisode | null;
  openPodcast: (podcast: Content.PodcastEpisode) => void;
  closePodcast: () => void;
};

export const PlayerContext = createContext<PlayerContextType>({
  podcast: null,
  openPodcast: () => null,
  closePodcast: () => null,
});

export const PlayerContextProvider = ({ children }: PropsWithChildren) => {
  const [podcast, setPodcast] = useState<Content.PodcastEpisode | null>(null);

  return (
    <PlayerContext.Provider
      value={{
        podcast,
        openPodcast: (podcast) => setPodcast(podcast),
        closePodcast: () => setPodcast(null),
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => {
  const { podcast, openPodcast, closePodcast } = useContext(PlayerContext);

  return { podcast, openPodcast, closePodcast };
};
